export default {
  BARRIER: "BARIER",
  DOOR: "DOOR",
  GATE: "GATE"
};
